/**
 * 本地存储工具类
 */

/**
 * 安全地解析JSON字符串
 * @param {string} str - 要解析的JSON字符串
 * @param {*} defaultValue - 解析失败时的默认值
 * @returns {*} 解析结果或默认值
 */
export function safeJsonParse(str, defaultValue = null) {
  try {
    return str ? JSON.parse(str) : defaultValue;
  } catch (error) {
    console.warn('JSON解析失败:', error);
    return defaultValue;
  }
}

/**
 * 安全地设置localStorage
 * @param {string} key - 键名
 * @param {*} value - 值
 */
export function safeSetItem(key, value) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
    }
  } catch (error) {
    console.error('设置localStorage失败:', error);
  }
}

/**
 * 安全地获取localStorage
 * @param {string} key - 键名
 * @param {*} defaultValue - 默认值
 * @returns {*} 存储的值或默认值
 */
export function safeGetItem(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : defaultValue;
  } catch (error) {
    console.warn(`获取localStorage[${key}]失败:`, error);
    // 清除无效数据
    localStorage.removeItem(key);
    return defaultValue;
  }
}

/**
 * 清理无效的localStorage数据
 */
export function cleanupInvalidStorage() {
  const keysToCheck = ['organizer_token', 'organizer_user_info'];
  
  keysToCheck.forEach(key => {
    try {
      const value = localStorage.getItem(key);
      if (value && key.includes('info')) {
        // 尝试解析JSON数据
        JSON.parse(value);
      }
    } catch (error) {
      console.warn(`清理无效的localStorage数据: ${key}`, error);
      localStorage.removeItem(key);
    }
  });
}
